import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/contact/page.tsx");
